import { Link } from "wouter-preact";

export function NotFound(): preact.JSX.Element {
  return (
    <main class="min-h-dvh flex flex-col items-center justify-center gap-3 px-4 text-center">
      <p class="text-xs font-semibold tracking-widest uppercase text-[color:var(--color-primary)]">
        404
      </p>
      <h1 class="text-2xl font-bold text-[color:var(--color-on-surface)]">
        Seite nicht gefunden
      </h1>
      <Link
        href="/"
        class="text-sm font-medium text-[color:var(--color-primary)] hover:underline"
      >
        Zurück zur Startseite
      </Link>
    </main>
  );
}
